import { useLocation } from "react-router-dom";
import EnquiryForm from "@/components/EnquiryForm";

export default function EnquiryPage() {
  const location = useLocation();
  const preselect = location.state?.product ? [location.state.product] : [];
  return (
    <div className="pt-16">
      <EnquiryForm preselect={preselect} />
    </div>
  );
}
